import { MODAL_CLOSE_TIMEOUT_ANIMATED } from '@porterin/feature/src/shared/modal/domain/entities/ModalEntities';
import styles from '@porterin/feature/src/ui/styles/common/BookingDetails.module.scss';
import React from 'react';
import ReactModal from 'react-modal';

import { make as SpotRequirementCmp } from './SpotRequirementCmp.mjs';

interface SpotRequirementModalProps {
  modal_state: boolean;
  close_modal: () => void;
  requirement: unknown;
  form: unknown;
  requirement_content: unknown;
}

function SpotRequirementModal({
  modal_state,
  close_modal,
  requirement,
  form,
  requirement_content,
}: Readonly<SpotRequirementModalProps>): React.ReactElement {
  return (
    <ReactModal
      isOpen={modal_state}
      onRequestClose={close_modal}
      closeTimeoutMS={MODAL_CLOSE_TIMEOUT_ANIMATED}
      overlayClassName={styles['overlay']}
      className={styles['modal-container']}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      <SpotRequirementCmp
        requirement={requirement}
        show_modal={close_modal}
        form={form}
        requirement_content={requirement_content}
      />
    </ReactModal>
  );
}

export default SpotRequirementModal;
